import { render } from "./dental_prescriptions.vue?vue&type=template&id=8e7d7c08&scoped=true"
import script from "./dental_prescriptions.vue?vue&type=script&lang=js"
export * from "./dental_prescriptions.vue?vue&type=script&lang=js"

import "./dental_prescriptions.vue?vue&type=style&index=0&id=8e7d7c08&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e7d7c08"]])

export default __exports__